<template>
  <Slide>
    <router-link
      v-for="(row, key) in menu"
      :key="key"
      :to="row.link"
      v-show="checkAccess(row.access)"
    >
      <span>{{ row.title }}</span>
    </router-link>
  </Slide>
</template>

<script>
import { Slide } from "vue-burger-menu";

export default {
  name: "Menu",
  props: {
    menu: {
      type: Array
    }
  },
  computed: {
    auth: function() {
      return this.$store.getters["auth/isAuthenticated"];
    },
    access: function() {
      return this.$store.getters["user/getProfileAccess"];
    }
  },
  components: {
    Slide
  },
  methods: {
    checkAccess: function(block) {
      if (block) {
        return this.auth && this.access.includes(block);
      } else {
        return !this.auth;
      }
    }
  }
};
</script>

<style>
.bm-burger-button {
  left: 30px !important;
  top: 30px !important;
}
</style>
